import { RouteType } from "../../../types/RouteType";
import { ContactsListStore } from "./ContactsList.Store";
import { ContactFormStore } from "./dialogs/ContactForm/ContactForm.Store";
import { RootStore } from "@intrasync/stores";

const contactsListRoute: RouteType = {
  name: "Contacts",
  path: "/crm/contacts",
  layout: "/app",
  hidden: true,
  viewportCard: {
    header: {
      title: "Contacts",
      component: () => import("./ContactsList.Header"),
    },
    body: {
      grayBackground: true,
      component: () => import("./ContactsList.Body"),
    },
  },
  group: "CRM",
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Load contacts data before entering the route
    const contactsListStore = rootStore.contactsListStore as ContactsListStore;
    await contactsListStore.loadContacts();
    return true;
  },
  dialogs: [
    {
      name: "Contact Form",
      component: () => import("./dialogs/ContactForm/ContactForm.Body"),
      title: "Contact Form",
      height: 700,
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const contactFormStore = rootStore.contactFormStore as ContactFormStore;

        const result = await contactFormStore.saveContact();
        if (result) {
          // Refresh the contacts list after successful submission
          const contactsListStore =
            rootStore.contactsListStore as ContactsListStore;
          await contactsListStore.loadContacts();
        }
        return result;
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const contactFormStore = rootStore.contactFormStore as ContactFormStore;
        return !contactFormStore.validateForm();
      },
    },
    {
      name: "contactDetail",
      component: () => import("./dialogs/ContactDetail/ContactDetail.Body"),
      title: "Contact Details",
      cancelButton: true,
      height: 800,
    },
  ],
};

export default contactsListRoute;
